import { useFormContext, useFormState, useWatch } from "react-hook-form";

import { RenderElement } from "@up/form";

export function CollegeCurrentSchoolState({
  label = "Current School State",
}: {
  label?: string;
}) {
  const { control, register } = useFormContext();
  const { errors } = useFormState();
  const formValues = useWatch();

  return (
    <RenderElement
      control={control}
      element={{
        _id: "college-current-school-address-state",
        type: "stateselect",
        name: "college-current-school-address-state",
        label: label,
        validate: {
          presence: true,
        },
        dependent: {
          dependentName: "college-current-school-address-country",
          condition: "equal",
          conditionValue: "United States",
        },
      }}
      errors={errors}
      formValues={formValues}
      register={register}
      wrapperProps={{ className: "mb-8" }}
    />
  );
}
